
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.51 3.091C13.624 1.225 11.67 0 9.497 0h-6.88L0 15h4.332l-.523 3h5.91l.786-4.5H13.5c2.701 0 4.982-1.845 5.424-4.387.254-1.452-.123-2.893-1.06-4.06a5.567 5.567 0 00-3.354-1.962zM4.591 13.5H1.854l2.094-12h5.55c1.668 0 3.16 1.011 3.711 2.516.216.59.273 1.23.163 1.85C13.057 7.68 11.427 9 9.498 9h-4.12l-.786 4.5zm12.782-4.635C17.058 10.683 15.429 12 13.499 12H9.175l-.785 4.5H5.663l1.046-6h2.79c.216 0 .43-.016.64-.04 2.23-.245 4.072-1.752 4.66-3.822a5.13 5.13 0 00.123-.525v-.008c.037-.21.06-.422.07-.634v-.017c.009-.21.003-.42-.015-.63 0-.01 0-.02-.002-.03v-.02c.64.249 1.211.66 1.641 1.193.67.833.939 1.862.758 2.898z","fill":"#fff"}})])
          )
        }
      }
    